import Menu from '@mindtickle/menu';

import { StyledHeaderMenuItemGroup } from './style';

interface ProfileMenuOptionProps {
  profileMenuOptions: Record<string, any>;
}

const ProfileMenuOption = ({ profileMenuOptions }: ProfileMenuOptionProps) => {
  const options = Object.values(profileMenuOptions);

  return (
    <Menu>
      {options.map(({ content, dataTestId, ...option }, index) => (
        <>
          {option?.overrideItemStyle ? (
            <StyledHeaderMenuItemGroup
              $showBottomBorder={!!option.showBottomBorder}
              key={`${content}-${index}`}
              title={content}
              data-testid={dataTestId}
            />
          ) : (
            content
          )}
        </>
      ))}
    </Menu>
  );
};

export default ProfileMenuOption;
